import { Type } from '../../../../redux/Transaction/helper';
import dayjs from 'dayjs';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import TransactionActions from '../../../../redux/Transaction/actions';
import { Helper as InvoiceHelper } from '../../../../containers/AppPage/Sales/Invoices/helper';
import { useCallback } from 'react';

const {
    changeDate,
} = TransactionActions;

const selectorFn = state => ({
    terms: state.List.terms,
    currencyCode: state.Transaction.currencyCode,
    termId: state.Transaction.termId,
    paymentMode: state.Transaction.paymentMode,
});

export function useDate({ form, isRecurring, transactionType }, readExchangeRate) {
    const dispatch = useDispatch();

    // Redux List
    const {
        terms,
        currencyCode,
        termId,
        paymentMode,
    } = useSelector(selectorFn, shallowEqual);

    const dateChanged = useCallback((dateString, updateForm = false) => {
        dispatch(
            changeDate(dateString),
        );

        if (updateForm)
            form.setFieldsValue({ date: dateString });

        // Side effects: Read exchange rate if not home currency.
        if (dateString)
            readExchangeRate(currencyCode, dateString);

        if (
            transactionType === Type.purchase_bill &&
            termId && isRecurring && paymentMode !== 'cash'
        ) {
            const term = terms.findWhere(term => term.id === termId);
            if (term)
                form.setFieldsValue({due_date: dayjs(InvoiceHelper.calcDueDateByTerm(term, dateString))});
        }
    }, [
        currencyCode,
        dispatch,
        form,
        isRecurring,
        paymentMode,
        readExchangeRate,
        termId,
        terms,
        transactionType,
    ]);

    const onDateChange = useCallback(newDate => {
        const dateString = dayjs(newDate).format("YYYY-MM-DD");
        dateChanged(dateString);
    }, [dateChanged]);

    return {
        onDateChange,
    };
}
